export const splitName = (name) => {
  if (!name) return { fname: "", lname: "" };
  const splitted = name.replace(/\s+/g, " ").trim().replace("&", "").split(" ");

  return {
    fname: splitted[0].trim(),
    lname: splitted.splice(1, splitted.length).join(" ").trim(),
  };
};

export const fullName = ({ fname, lname }) => [fname, lname].filter(Boolean).join(" ");

export default splitName;
